import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LoginModal from './LoginModal';

function Navbar() {
  const [showLogin, setShowLogin] = useState(false);
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const navigate = useNavigate();

  const handleLogin = (userData) => {
    setUser(userData);
    setShowLogin(false);
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('userToken');
    navigate('/');
  };

  // Bestem hvilken dashboard-rute som skal brukes basert på brukertype
  const getDashboardRoute = () => {
    if (user?.isHR) return '/hr-dashboard';
    if (user?.isAdmin) return '/admin';
    if (user?.isAppUser) return '/app-interface';
    return '/dashboard';
  };

  return (
    <>
      <nav style={{
        backgroundColor: '#fff',
        padding: '1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <Link to="/" style={{
          textDecoration: 'none',
          color: '#333',
          fontSize: '1.5rem',
          fontWeight: 'bold'
        }}>
          Pure Paths
        </Link>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          {user ? (
            <>
              <span style={{ color: '#666' }}>
                Welcome, {user.companyName}
              </span>
              <Link 
                to={getDashboardRoute()}
                style={{
                  backgroundColor: '#FF0',
                  color: '#000',
                  padding: '0.5rem 1rem',
                  borderRadius: '5px',
                  border: 'none',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s'
                }}
              >
                Dashboard
              </Link>
              <button 
                onClick={handleLogout}
                style={{
                  backgroundColor: '#FF0',
                  color: '#000',
                  padding: '0.5rem 1rem',
                  borderRadius: '5px',
                  border: 'none',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s'
                }}
              >
                Logout
              </button>
            </>
          ) : (
            <button 
              onClick={() => setShowLogin(true)}
              style={{
                backgroundColor: '#FF0',
                color: '#000',
                padding: '0.5rem 1rem',
                borderRadius: '5px',
                border: 'none',
                textDecoration: 'none',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'background-color 0.3s'
              }}
            >
              Login
            </button>
          )}
        </div>
      </nav>

      <LoginModal 
        isOpen={showLogin} 
        onClose={() => setShowLogin(false)}
        onLogin={handleLogin}
      />
    </>
  );
}

export default Navbar; 